import ComingSoon from '../ComingSoon';
import { Network } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

const KnowledgeGraph = () => {
  return (
    <div className="h-full w-full p-4">
      <Card className="h-full">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Network className="h-5 w-5" />
            Knowledge Graph
          </CardTitle>
        </CardHeader>
        <CardContent>
          <ComingSoon
            title="Knowledge Graph"
            description="Interactive visualization of document relationships, entities, and connections will be available soon."
            icon={<Network className="h-8 w-8 text-blue-600" />}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default KnowledgeGraph;
